import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ProjectService} from '../../../../../../shared/services/project/project.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../../../shared/services/user/user.service';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {StatesService} from '../../../../../../shared/services/state/states.service';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../../../../../../environments/environment';
import {ProjectUser} from '../../../../../../shared/classes/project-user/project-user';
import {AuthenticationService} from '../../../../../../shared/services/authentication/authentication.service';

@Component({
    selector: 'app-project-user-add-list',
    templateUrl: './project-user-add-list.component.html',
    styleUrls: ['./project-user-add-list.component.css']
})
export class ProjectUserAddListComponent implements OnInit {

    public displayedColumns: string[] = ['roles', 'email', 'firstname', 'lastname', 'action'];
    public users: MatTableDataSource<any>;
    public faPlus = faPlus;

    public showSpinner: boolean = false;
    @Input('projectId') projectId: number = null;
    @Input('projectLevel') projectLevel: number = null;
    public projectUsers: any[] = [];

    public roles = [{value: 1, name: 'client'}, {value: 2, name: 'installer'}];

    public rolesSelected: string = 'client,installer';

    public pageSizeOptions = environment.pageSizeOptions;
    public pageSize = environment.pageSize;

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    constructor(public activeModal: NgbActiveModal,
                private userService: UserService,
                private projectService: ProjectService,
                private statesService: StatesService,
                private toastr: ToastrService,
                private translate: TranslateService) {
    }

    ngOnInit() {
        this.initProject();
    }

    filterListByRole(role: string) {
        if (this.rolesSelected !== role) {
            this.rolesSelected = role;
        } else {
            this.rolesSelected = 'client,installer';
        }
        this.initUsers();
    }

    private initProject() {

        this.showSpinner = true;
        this.projectService.getProject(this.projectId, 'users')
            .subscribe(
                (data: any) => {
                    this.projectUsers = data.project_users;
                    this.initUsers();
                },
                (error2) => {
                    this.showSpinner = false;
                }
            );
    }

    private initUsers() {
        this.showSpinner = true;
        let usersIdList: any[] = [];
        this.projectUsers.forEach(user => {
            usersIdList.push(user.user.id);
        });
        this.userService.getUsers(this.projectLevel, true, this.rolesSelected,true)
            .subscribe(
                (data: any) => {

                    let userTemp: any[] = [];
                    data.forEach(d => {
                        if (!usersIdList.includes(d.id)) {
                            userTemp.push(d);
                        }
                    });
                    this.users = new MatTableDataSource(userTemp);
                    this.users.filter = null;
                    this.users.sort = this.sort;
                    this.users.paginator = this.paginator;
                    this.showSpinner = false;
                }
                ,
                error2 => {
                    this.showSpinner = false;

                }
            );
    }


    public addUserToProject(userId: number, userEmail: string) {
        this.showSpinner = true;
        let projectUser: ProjectUser = new ProjectUser();
        projectUser.active = true;
        projectUser.user = userId;
        //  projectUser.isMainUser = false;
        this.projectService.postProjectUser(this.projectId, projectUser)
            .subscribe(
                (data: any) => {
                    this.toastr.success(userEmail + ' ' + this.translate.instant('ADDED_TO_PROJECT'), this.translate.instant('SUCCESS'));
                    this.showSpinner = false;
                    this.statesService.reloadProjectUserRemove.next();
                    this.initProject();
                }
                ,
                error2 => {
                    this.showSpinner = false;
                }
            );
    }

    public getClientOrInstallerRoles(roles: any[]) {
        return this.userService.getClientOrInstallerRoles(roles);
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.users.filter = filterValue;
    }
}
